// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

interface TranslateProps {
  className?: string;
}

export function Translate({ className }: TranslateProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.13338 14.4L10.9834 6.79998H12.35L15.2 14.4H13.8834L13.2 12.45H10.1334L9.45005 14.4H8.13338ZM2.81672 12.4L1.98338 11.55L5.18338 8.38331C4.78338 7.96109 4.41116 7.5222 4.06672 7.06664C3.72227 6.61109 3.42227 6.11664 3.16672 5.58331H4.53338C4.73338 5.93886 4.93338 6.24164 5.13338 6.49164C5.33338 6.74164 5.62227 7.07775 6.00005 7.49998C6.42227 7.03331 6.81116 6.5472 7.16672 6.04164C7.52227 5.53609 7.81116 4.98886 8.03338 4.39998H0.800049V3.19998H5.40005V1.59998H6.60005V3.19998H11.2V4.39998H9.30005C9.06672 5.16664 8.72783 5.87498 8.28338 6.52498C7.83894 7.17498 7.35005 7.79442 6.81672 8.38331L8.33338 9.88331L7.86671 11.1166L6.00005 9.24998L2.81672 12.4ZM10.5334 11.35H12.8L11.7 8.19998L10.5334 11.35Z"
        fill="currentColor"
      />
    </svg>
  );
}
